<button [class]="class" [type]="type" *ngIf="buttonType==='icon'" mat-mini-fab [matMenuTriggerFor]="menu"
	#menuTrigger="matMenuTrigger" [matTooltip]="tooltip" [color]="color" (click)="openMenu()" [disabled]="disabled">
	<mat-icon>{{icon}}</mat-icon>
</button>
<button [class]="class" [type]="type" *ngIf="buttonType==='mini-icon'" mat-icon-button [matMenuTriggerFor]="menu"
	#menuTrigger="matMenuTrigger" [matTooltip]="tooltip" [color]="color" (click)="openMenu()" [disabled]="disabled">
	<mat-icon>{{icon}}</mat-icon>
</button>
<button [class]="class" [type]="type" *ngIf="buttonType==='mini-raised-icon'" mat-mini-fab [matMenuTriggerFor]="menu"
	#menuTrigger="matMenuTrigger" [matTooltip]="tooltip" [color]="color" (click)="openMenu()" [disabled]="disabled">
	<mat-icon>{{icon}}</mat-icon>
</button>
<button [class]="class" [type]="type" *ngIf="buttonType==='string'" mat-raised-button [matMenuTriggerFor]="menu"
	#menuTrigger="matMenuTrigger" [matTooltip]="tooltip" [color]="color" (click)="openMenu()" [disabled]="disabled">
	<mat-icon *ngIf="isLoading">
		<mat-spinner diameter="18"> </mat-spinner>
	</mat-icon>
	{{buttonTxt}}
</button>
<button class="collapseconfirm" [type]="type" *ngIf="buttonType==='stringicon'" mat-raised-button
	[matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" [matTooltip]="tooltip" [color]="color" (click)="openMenu()"
	[disabled]="disabled">
	<mat-icon>{{icon}}</mat-icon>{{buttonTxt}}
</button>

<mat-menu class="padding-horizontal-sm" #menu="matMenu">
	<div (click)="$event.stopPropagation()" class="overflow-hidden">
		<!--  [ngClass]="{'custom-min-width': buttonType === 'stringicon'}"
		[class.collapseconfirm]="buttonType === 'stringicon'" -->
		<div class="text-center row">

			<div [innerHTML]="popoverMsg"></div>
		</div>
		<hr />
		<div class="row">
			<div class="col text-center">
				<button [color]="popoverConfirmColor" mat-raised-button (click)="confirm()" #confirmElement
					tabindex="1000">{{popoverConfirmText}}</button>
			</div>
			<div class="col text-center">
				<button [color]="popoverCancelColor" mat-raised-button (click)="closeMenu()"
					tabindex="1001">{{popoverCancelText}}</button>
			</div>
		</div>
	</div>
</mat-menu>